import { useEffect, useState } from 'react';
import { getTurboDataSourceOptions } from '@/service';
import { useIntl } from 'react-intl';
import { Col } from 'antd';
import { Typography } from 'iglooform';
import './index.less';

interface IDynamicItem {
  config: any;
  formValue: any;
  isPc: boolean;
}

const DynamicItem = (props: IDynamicItem) => {
  const { config, formValue, isPc = false } = props;
  const [loading, setLoading] = useState(true);
  const [displayVal, setDisplayVal] = useState('');

  const { formatMessage: originalFormatMessage } = useIntl();

  const formatMessage = ({ id }: { id: string | undefined }) => {
    return id ? originalFormatMessage({ id }) : '';
  };

  const { datasourceKey, name, label, dependField } = config;

  useEffect(() => {
    getTurboDataSourceOptions(
      datasourceKey,
      dependField
        ? { parent: formValue[dependField[dependField.length - 1]] }
        : {},
    )
      .then((res) => {
        if (res.data) {
          setDisplayVal(
            res?.data?.find((i: any) => i.value === formValue[name])?.label ||
              formValue[name],
          );
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const h5Item = (
    <div style={{ marginBottom: 8 }}>
      <Typography level="body2" className="title" wrapElement="div">
        {formatMessage({ id: label })}
      </Typography>
      <Typography level="body2">{loading ? '' : displayVal}</Typography>
    </div>
  );

  const pcItem = (
    <Col span={6} style={{ marginBottom: '16px' }}>
      <Typography level="body1" className="title">
        {formatMessage({ id: label })}
      </Typography>
      <Typography level="body1">{loading ? '' : displayVal}</Typography>
    </Col>
  );

  return <>{isPc ? pcItem : h5Item}</>;
};

export default DynamicItem;
